module.exports = __webpack_public_path__ + "static/media/dailyDocuments.f5a82a36.svg";